import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ArrivalTasksService from '_services/arrival-tasks-service';

export const fetchArrivalTasks = createAsyncThunk(
  'arrivalTasks/fetch',
  async (params, { signal }) => {
    return await ArrivalTasksService.getArrivalTasks(params, signal);
  },
  {
    condition: (_params, { getState }) => {
      if (getState().arrivalTasks.status === 'loading') return false;
    },
  }
);

const initialState = {
  data: null,
  status: 'idle',
  error: null,
};

const arrivalTasksSlice = createSlice({
  name: 'arrivalTasks',
  initialState,
  reducers: {
    resetArrivalTasks: (state) => {
      state.data = null;
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchArrivalTasks.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchArrivalTasks.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchArrivalTasks.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const selectArrivalTasksData = (state) => state.arrivalTasks.data;
export const selectArrivalTasksStatus = (state) => state.arrivalTasks.status;
export const selectArrivalTasksError = (state) => state.arrivalTasks.error;

export const { resetArrivalTasks } = arrivalTasksSlice.actions;

export default arrivalTasksSlice.reducer;
